import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { LOGIN } from '@symphony-solo/shared/utils/src';
import { CompanyGroupFacade } from '@symphony-solo/domain/company-group/src';
import { AuthenticationFacade } from '../+state';
import { combineLatest, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { CompanyConfigFacade, CompanyConfigType } from '@symphony-solo/domain/company-config/src';

@Injectable()
export class ServiceEndedGuard implements CanActivate {
  constructor(
    private navCtrl: NavController,
    private platform: Platform,
    private companyGroupFacade: CompanyGroupFacade,
    private authenticationFacade: AuthenticationFacade,
    private companyConfigFacade: CompanyConfigFacade
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isWeb = !this.platform.is('capacitor') && !this.platform.is('cordova');

    if (isWeb) {
      this.companyGroupFacade.getCompanyGroupBySubDomain();
    } else {
      this.companyGroupFacade.getCompanyGroup(null);
    }

    return combineLatest([
      this.authenticationFacade.isAuthenticated$,
      this.companyConfigFacade.companyConfigIndex$,
      this.companyGroupFacade.companyGroupInfo$,
    ]).pipe(
      first(),
      map(([isLoggedIn, companyConfigIndex, company]) => {
        if (!company) {
          console.error('Company data is not available');
          return false;
        }

        this.setComapnyTheme(companyConfigIndex, company);

        if (!isWeb) {
          if (company.enabled === false) {
            this.companyGroupFacade.serviceEnded();
            return false;
          } else if (company.enabled === true && state.url.includes('ended')) {
            this.navCtrl.navigateBack(isLoggedIn ? '/app' : LOGIN);
            return false;
          } else {
            if (state.url.includes(LOGIN) && isLoggedIn) {
              this.navCtrl.navigateBack('/app');
              return false;
            } else {
              return true;
            }
          }
        } else {
          if (company?.enabled === false) {
            this.companyGroupFacade.serviceEnded();
            return false;
          } else {
            return true;
          }
        }
      }),
      catchError((error) => {
        return of(false);
      })
    );
  }

  private setComapnyTheme(companyConfigIndex, companyGroupInfo) {
    if (companyConfigIndex) {
      const DEFAULT_COLOR_FOR_TEXT = '#000000';
      const soloAltColourForTextIconOnBackground = companyConfigIndex[CompanyConfigType.SoloAltColourForTextIconOnBackground];
      if (soloAltColourForTextIconOnBackground && soloAltColourForTextIconOnBackground !== DEFAULT_COLOR_FOR_TEXT) {
        this.companyConfigFacade.setIsContrastColor(true);
      }
    }

    const htmlEl = document.querySelector('html');
    htmlEl.style.setProperty('--ion-color-primary', companyGroupInfo.primaryColour);
    htmlEl.style.setProperty('--ion-color-secondary', companyGroupInfo.secondaryColour);
  }
}
